import { UploadStrategyBase } from './upload-strategy-base';
import { FileType } from '@models/file-type';
import { Injectable } from '@angular/core';
import { DocService } from '@services/doc.service';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';
import { map, Observable } from 'rxjs';
import { AppStore } from '@store/legacy/app.store';

@Injectable({
	providedIn: 'root'
})
export class TranslationUploadStrategy extends UploadStrategyBase {
	public title = 'Manual Translation';
	public message = 'From here you can upload a document that has been previously translated outside.  Alternatively, you request our Auto-Translation Services.  See help for more details.  Upload previously translated document:';
	private warningIfTranslatedDocumentAlreadyExists = 'Warning: A translated document already exists. Uploading a new translated PDF will overwrite existing translated document.';
	private errorIfCaseIsAlreadyProcessing = 'Cannot upload Translated PDF while case is processing.';

	constructor(
		protected docService: DocService,
		protected docViewerStore: DocViewerStore,
		private appStore: AppStore
	) {
		super(docService, docViewerStore);
	}

	public warning$(): Observable<string> {
		return this.docViewerStore.simpleState$.pipe(
			map((state) => state.hasTranslation ? this.warningIfTranslatedDocumentAlreadyExists : '')
		)
	}

	public error$(): Observable<string> {
		return this.appStore.appState$.pipe(
			map((state) => state.isCaseProcessing ? this.errorIfCaseIsAlreadyProcessing : '')
		);
	}

	public tryUpload(file: File): Observable<string> {
		return this.uploadInternal(file, FileType.NormalizedTranslatedFile);
	}
}
